/*
IMPORTANT
This file should always match the one in the Functions code
This is where we define the inner objects
*/

export const ReverseChoices = [
    { id: '0', name: '' },
    { id: '1', name: 'Guasto al Primo utilizzo' }
];

export const CausaliChoices = [
    { id: '930', name: 'UM per Vendita', tipo: 'Delivery' },
    { id: '940', name: 'UM per Noleggio', tipo: 'Delivery' },
    { id: '946', name: 'UM per sostituzione su guasto', tipo: 'Assurance' },
    { id: '936', name: 'UM per manutenzione su vendita', tipo: 'Assurance' },
    { id: '9A5', name: "UM per Comodato d'Uso", tipo: 'Delivery' },
    { id: '950', name: 'Infrastruttura', tipo: 'Delivery' },
    { id: '9O1', name: "UM Delivery di TERZI", tipo: 'Delivery/Assurance' },
    { id: '9O7', name: "UM Assurance di TERZI", tipo: 'Assurance' }
];

//Partita
export const CodStatoUsoChoices = [
    { id: '1', name: 'Nuovo' },
    { id: '3', name: 'Riutilizzato' }
];

export const Anomalie = [
    { id: '0', name: 'SN NON ANAGRAFATO' },
    { id: '1', name: 'SN ASSOCIATO AD ALTRA WR' },
    { id: '2', name: 'SN ATTRIBUITO AD ALTRA IMPRESA' },
    { id: '3', name: 'WR NON RICONOSCIUTA' },
    { id: '4', name: 'WR GIA ASSOCIATA' },
    //{ id: '5', name: 'WR ASSEGNATA A DIFFERENTE IMPRESA' },
    { id: '6', name: 'ERRATA ATTRIBUZIONE SN AL MAGAZZINO' },
    //{ id: '7', name: 'CAUSALE NON COMPATIBILE' },
    { id: '8', name: 'GUASTO AL PRIMO UTILIZZO' },
    { id: '9', name: 'WR DUPLICATA' },
    { id: '10', name: 'IMPIANTO OLO' },
    { id: '11', name: 'WR SENZA CONSEGNA PRODOTTI' },
    { id: '12', name: 'NMU NON COMPATIBILE' },
    { id: '13', name: 'GUASTO SENZA CONSEGNA PRODOTTO' },
    { id: '14', name: 'CAUSALE NON TROVATA' },
    { id: '15', name: 'MATCH TELEFONICO REGMAN KO' },
    { id: '16', name: 'SN RELATIVO TERRITORIO/NMU NON ANAGRAFATI' },
    { id: '17', name: 'SN PRECEDENTEMENTE ASSOCIATO CON ERRORE' },
    { id: '18', name: 'SCARICATA SU TELESAP' },
    { id: '19', name: 'OL CESSATO' },
    //{ id: '20', name: 'GIACENZA NMU A ZERO' },
    { id: '21', name: 'SN ERRATO' },
    { id: '23', name: 'FAMIGLIA PRODOTTO NON COMPATIBILE' },
    { id: '24', name: 'ASSOCIAZIONE SN-WR ERRATA' },
    { id: '25', name: 'CHECK COLLAUDO_ONE KO'},       
    { id: '26', name: 'FURTO'},
    { id: '27', name: 'GIA SCARICATA MOS'},
    { id: '28', name: 'MATERIALE MOS'},
    { id: '29', name: 'SMARRITO'},
    { id: '30', name: 'FITTIZIO'},
    { id: '31', name: 'RESO'},
    { id: '32', name: 'AMMANCO INVENTARIO'},
    { id: '33', name: 'SK U0009T MANCANTE'},
    { id: '34', name: 'SK U0009T ANNULLATA'},
    { id: '35', name: 'ERRATO ADDEBITO SU SK U0009T'},
    { id: '36', name: 'NON FATTURATO'},
    { id: '37', name: 'ERRORE CONSEGNA'}
];

export const CheckNMU = [
    { id: 'NULL', name: ' ' },
    { id: 'WR SENZA CONSEGNA PRODOTTI', name: 'WR SENZA CONSEGNA PRODOTTI' },
    { id: 'ROUTER LIBERO', name: 'ROUTER LIBERO' },
    { id: 'NMU NON COMPATIBILE', name: 'NMU NON COMPATIBILE' },
    { id: 'NMU OK', name: 'NMU OK' },
    { id: 'FAMIGLIA NMU NON PREVISTA', name: 'FAMIGLIA NMU NON PREVISTA' },
    { id: 'NA', name: 'NA' }
]


export const Statuses = [
    { id: '0', name: 'Da Esaminare' },
    { id: '1', name: 'Attribuito' },
    { id: '2', name: 'Associato' },
    { id: '3', name: 'Validato' },
    { id: '4', name: 'Approvato' },
    { id: '5', name: 'Scaricato' },
    { id: '6', name: 'Attribuito_MOS' },
    { id: '7', name: 'Associato_MOS' },
    { id: '8', name: 'Scaricato_MOS' },
    { id: '9', name: 'Chiuso' },
    { id: '11', name: 'In attesa di scarico' },
    { id: '12', name: 'Da Scaricare' }
];

//All statuses
export const AllStatuses = [
    { id: '0', name: 'Da Esaminare' },
    { id: '1', name: 'Attribuito' },
    { id: '2', name: 'Associato' },
    { id: '3', name: 'Validato' },
    { id: '4', name: 'Approvato' },
    { id: '5', name: 'Scaricato' },
    { id: '6', name: 'Attribuito_MOS' },
    { id: '7', name: 'Associato_MOS' },
    { id: '8', name: 'Scaricato_MOS' },
    { id: '11', name: 'In attesa di scarico' },
    { id: '12', name: 'Da Scaricare' }
];

export const Statuses_Mag_Device = [
    { id: '0', name: 'Da Esaminare' },
    { id: '1', name: 'Attribuito' },
    { id: '2', name: 'Associato' },
    { id: '3', name: 'Validato' },
    { id: '4', name: 'Approvato' },
    { id: '5', name: 'Scaricato' },
    { id: '6', name: 'Attribuito_MOS' },
    { id: '7', name: 'Associato_MOS' },
    { id: '8', name: 'Scaricato_MOS' },
    { id: '12', name: 'Da Scaricare' },
];

//All statuses
export const Status_Regman = [
    { id: '0', name: 'NO DISCOVERATO SU REGMAN' },
    { id: '1', name: 'DISCOVERATO SU REGMAN' },
    { id: '2', name: 'MATCH REGMAN KO' },
    { id: '3', name: 'MATCH REGMAN OK' },
];

export const Causale_Addebito = [
    { id: '0', name: 'U0009T MANCANTE O ERRATO' },
    { id: '1', name: 'SCARICO INDEBITO' }
];

export const Causale_Addebito_Filter = [
    { id: 'NULL', name: ' ' },
    { id: '0', name: 'U0009T MANCANTE O ERRATO' },
    { id: '1', name: 'SCARICO INDEBITO' }
];

export const Statuses_DG_Filter = [
    { id: '0', name: 'Da Esaminare' },
    { id: '1', name: 'Attribuito' },
    { id: '2', name: 'Associato' },
    { id: '3', name: 'Validato' },
    { id: '4', name: 'Approvato' },
    { id: '5', name: 'Scaricato' },
    { id: '6', name: 'Attribuito_MOS' },
    { id: '7', name: 'Associato_MOS' },
    { id: '8', name: 'Scaricato_MOS' },
];

//Transition from Associato (Magazziniere)
export const Statuses_2_Magazziniere = [
    { id: '2', name: 'Associato' },
    { id: '3', name: 'Validato' }
];

//Transition from Associato (Magazziniere)
export const Statuses_2_Magazziniere_OtherCodTerrSAP = [
    { id: '1', name: 'Attribuito' },
    { id: '2', name: 'Associato' }
];

//Transition from Atribuito (Magazziniere)
export const Statuses_1_Magazziniere = [
    // { id: '0', name: 'Da Esaminare' },
    { id: '1', name: 'Attribuito' },
    { id: '2', name: 'Associato' }
];
//Transition from Associato (Magazziniere)
export const Statuses_2_MagazziniereIB = [
    // { id: '0', name: 'Da Esaminare' },
    { id: '6', name: 'Attribuito_MOS' },
    { id: '7', name: 'Associato_MOS' }
];

//Transition from Associato (Magazziniere)
export const Statuses_2_MagazziniereIB_OtherCodTerrSAP = [
    { id: '6', name: 'Attribuito_MOS' },
    { id: '7', name: 'Associato_MOS' }
];

export const Statuses_0_Magazziniere = [
    { id: '0', name: 'Da Esaminare' },
    { id: '2', name: 'Associato' }
];

//Transition from Da Esaminare e Guasto al primo utilizo (Magazziniere)
export const Statuses_0_Magazziniere_Guasto = [
    { id: '0', name: 'Da Esaminare' },
    { id: '2', name: 'Associato' },
    { id: '9', name: 'Chiuso' },
];

export const Statuses_0_MagazziniereIB = [
    { id: '0', name: 'Da Esaminare' },
    { id: '7', name: 'Associato_MOS' },
];

export const Statuses_1_Approvatore = [
    { id: '0', name: 'Da Esaminare' },
    { id: '1', name: 'Attribuito' },
    { id: '6', name: 'Attribuito_MOS' },
    { id: '2', name: 'Associato' },
    { id: '12', name: 'Da Scaricare' },
];

//Transitions from Validato (Approvatore)
export const Statuses_3_Approvatore = [
    { id: '0', name: 'Da Esaminare' },
    { id: '3', name: 'Validato' },
    { id: '4', name: 'Approvato' },
    { id: '5', name: 'Scaricato' }
];

//Transitions from Approvato (Approvatore)
export const Statuses_4_Approvatore = [
    { id: '3', name: 'Validato' },
    { id: '4', name: 'Approvato' }
];

//Transitions from Da Esaminare (Approvatore)
export const Statuses_5_Approvatore = [
    { id: '0', name: 'Da Esaminare' },
    { id: '9', name: 'Chiuso' }
];

//Transitions from Attribuito (Approvatore)
export const Statuses_6_Approvatore = [
    { id: '1', name: 'Attribuito' },
    { id: '9', name: 'Chiuso' }
];

export const Statuses_7_Approvatore = [
    { id: '6', name: 'Attribuito_MOS' },
    { id: '9', name: 'Chiuso' }
];

export const Statuses_Approvatore_Filter = [
    { id: '3', name: 'Validato' },
    { id: '4', name: 'Approvato' },
];

//Transitions from Da Esaminare (Approvatore)
export const Statuses_0_Approvatore = [
    { id: '0', name: 'Da Esaminare' },
    { id: '3', name: 'Validato' }
];

export const Statuses_Approvatore_Apparati_Scaricati = [
    { id: '5', name: 'Scaricato' },
    { id: '9', name: 'Chiuso' },
    { id: '10', name: 'Disallineato' },
    { id: '11', name: 'In attesa di Scarico' },
];

export const Statuses_Apparati_Scaricati = [
    { id: '5', name: 'Scaricato' },
    { id: '8', name: 'Scaricato_MOS' },
    { id: '9', name: 'Chiuso' },
    { id: '10', name: 'Disallineato' },
    { id: '11', name: 'In attesa di scarico' }
];

export const Templates = [
    { id: 'tecnico', name: 'Tecnico' },
    { id: 'magazziniere', name: 'Magazziniere' },
    { id: 'approvatore', name: 'Approvatore' },
    { id: 'administrator', name: 'Admin' }
];

//Anomalie (Approvatore)
export const Anomalie_Approvatore_To_DaEsaminare = [
    { id: '10', name: 'IMPIANTO OLO' },
    { id: '11', name: 'WR SENZA CONSEGNA PRODOTTI' },
    { id: '12', name: 'NMU NON COMPATIBILE' },
    { id: '13', name: 'GUASTO SENZA CONSEGNA PRODOTTO' },
    { id: '15', name: 'MATCH TELEFONICO REGMAN KO' },
    { id: '19', name: 'OL CESSATO' },
    //{ id: '20', name: 'GIACENZA NMU A ZERO' },
    { id: '21', name: 'SN ERRATO' },
    { id: '22', name: 'NO DISCOVERATO SU REGMAN' },
    { id: '23', name: 'FAMIGLIA PRODOTTO NON COMPATIBILE' },
    { id: '24', name: 'ASSOCIAZIONE SN-WR ERRATA' },
    { id: '33', name: 'SK U0009T MANCANTE'},
    { id: '34', name: 'SK U0009T ANNULLATA'},
    { id: '35', name: 'ERRATO ADDEBITO SU SK U0009T'},
    { id: '36', name: 'NON FATTURATO'}
];

//Anomalie (Approvatore)
export const Anomalie_Approvatore_To_Scaricato = [
    { id: '18', name: 'SCARICATA SU TELESAP' }
];

//Anomalie (Approvatore)
export const Anomalie_Approvatore_Attribuito_To_Chiuso = [
    { id: '26', name: 'FURTO'},
    { id: '29', name: 'SMARRITO'},
    { id: '30', name: 'FITTIZIO'},
    { id: '31', name: 'RESO'},
    { id: '32', name: 'AMMANCO INVENTARIO'},    
    { id: '27', name: 'GIA SCARICATA MOS'},
    { id: '28', name: 'MATERIALE MOS'},
    { id: '37', name: 'ERRORE CONSEGNA'}
];

export const Anomalie_Approvatore_Attribuito_MOS_To_Chiuso = [
    { id: '26', name: 'FURTO'},
    { id: '29', name: 'SMARRITO'},
    { id: '30', name: 'FITTIZIO'},
    { id: '31', name: 'RESO'},
    { id: '32', name: 'AMMANCO INVENTARIO'},    
    { id: '27', name: 'GIA SCARICATA MOS'},
    { id: '28', name: 'MATERIALE MOS'},
    { id: '37', name: 'ERRORE CONSEGNA'}
];

//Anomalie (Approvatore)
export const Anomalie_Approvatore_DaEsaminare_To_Chiuso = [
    { id: '27', name: 'GIA SCARICATA MOS'},
    { id: '28', name: 'MATERIALE MOS'}
];

export const Anomalie_Magazziniere = [
    { id: '1', name: 'SN ASSOCIATO AD ALTRA WR' },
    { id: '3', name: 'WR NON RICONOSCIUTA' },
    { id: '4', name: 'WR GIA ASSOCIATA' },
    //{ id: '5', name: 'WR ASSEGNATA A DIFFERENTE IMPRESA' },
    { id: '6', name: 'ERRATA ATTRIBUZIONE SN AL MAGAZZINO' },
    //{ id: '7', name: 'CAUSALE NON COMPATIBILE' },
    { id: '8', name: 'GUASTO AL PRIMO UTILIZZO' },
    { id: '9', name: 'WR DUPLICATA' },
    { id: '10', name: 'IMPIANTO OLO' },
    { id: '11', name: 'WR SENZA CONSEGNA PRODOTTI' },
    { id: '12', name: 'NMU NON COMPATIBILE' },
    { id: '13', name: 'GUASTO SENZA CONSEGNA PRODOTTO' },
    { id: '14', name: 'CAUSALE NON TROVATA' },
    { id: '15', name: 'MATCH TELEFONICO REGMAN KO' },
    { id: '22', name: 'NO DISCOVERATO SU REGMAN' }
];

export const Anomalie_Magazziniere_Attr = [
    { id: '6', name: 'ERRATA ATTRIBUZIONE SN AL MAGAZZINO' }
];

export const Anomalie_Filter = [
    { id: null, name: 'SENZA ANOMALIA' },
    { id: '0', name: 'SN NON ANAGRAFATO' },
    { id: '1', name: 'SN ASSOCIATO AD ALTRA WR' },
    { id: '2', name: 'SN ATTRIBUITO AD ALTRA IMPRESA' },
    { id: '3', name: 'WR NON RICONOSCIUTA' },
    { id: '4', name: 'WR GIA ASSOCIATA' },
    //{ id: '5', name: 'WR ASSEGNATA A DIFFERENTE IMPRESA' },
    { id: '6', name: 'ERRATA ATTRIBUZIONE SN AL MAGAZZINO' },
    //{ id: '7', name: 'CAUSALE NON COMPATIBILE' },
    { id: '8', name: 'GUASTO AL PRIMO UTILIZZO' },
    { id: '9', name: 'WR DUPLICATA' },
    { id: '10', name: 'IMPIANTO OLO' },
    { id: '11', name: 'WR SENZA CONSEGNA PRODOTTI' },
    { id: '12', name: 'NMU NON COMPATIBILE' },
    { id: '13', name: 'GUASTO SENZA CONSEGNA PRODOTTO' },
    { id: '14', name: 'CAUSALE NON TROVATA' },
    { id: '15', name: 'MATCH TELEFONICO REGMAN KO' },
    { id: '16', name: 'SN RELATIVO TERRITORIO/NMU NON ANAGRAFATI' },
    { id: '17', name: 'SN PRECEDENTEMENTE ASSOCIATO CON ERRORE' },
    { id: '18', name: 'SCARICATA SU TELESAP' },
    { id: '19', name: 'OL CESSATO' },
    //{ id: '20', name: 'GIACENZA NMU A ZERO' },
    { id: '21', name: 'SN ERRATO' },
    { id: '22', name: 'NO DISCOVERATO SU REGMAN' },
    { id: '23', name: 'FAMIGLIA PRODOTTO NON COMPATIBILE' },
    { id: '24', name: 'ASSOCIAZIONE SN-WR ERRATA' },
    { id: '25', name: 'CHECK COLLAUDO_ONE KO'},       
    { id: '26', name: 'FURTO'},
    { id: '27', name: 'GIA SCARICATA MOS'},
    { id: '28', name: 'MATERIALE MOS'},
    { id: '29', name: 'SMARRITO'},
    { id: '30', name: 'FITTIZIO'},
    { id: '31', name: 'RESO'},
    { id: '32', name: 'AMMANCO INVENTARIO'},
    { id: '33', name: 'SK U0009T MANCANTE'},
    { id: '34', name: 'SK U0009T ANNULLATA'},
    { id: '35', name: 'ERRATO ADDEBITO SU SK U0009T'},
    { id: '36', name: 'NON FATTURATO'},
    { id: '37', name: 'ERRORE CONSEGNA'}
];

export const Flag_olo = [
    { id: 'SI', name: 'SI' },
    { id: 'NO', name: 'NO' }
]

export const Check_u0009t = [
    { id: 'OK', name: 'OK' },
    { id: 'KO', name: 'KO' }
]

export const Progetto_con_Scarico = [
    { id: 'NULL', name: ' ' },
    { id: 'SI', name: 'SI' },
    { id: 'NO', name: 'NO' }
]

export const OneStep = [
    { id: 'NULL', name: ' ' },
    { id: 'SI', name: 'SI' },
    { id: 'NO', name: 'NO' }
]

export const TipoNMU = [
    { id: 'NULL', name: ' ' },
    { id: 'ZRES', name: 'ZRES' },
    { id: 'ZUNB', name: 'ZUNB' },
    { id: 'ZES0', name: 'ZES0' }
]

export const TipoFamiglia = [
    { id: 'Router', name: 'Router' },
    { id: 'Repeater', name: 'Repeater' },
    { id: 'Decoder', name: 'Decoder' },
    { id: 'Altro', name: 'Altro' }
]

export const Status_Collaudo_One = [
    { id: '0', name: 'NO DISCOVERATO SU COLLAUDO_ONE' },
    { id: '1', name: 'DISCOVERATO SU COLLAUDO_ONE' },
    { id: '2', name: 'MATCH COLLAUDO_ONE KO' },
    { id: '3', name: 'MATCH COLLAUDO_ONE OK' }
]

/************** ENUMS **************/

export const TaskStatuses_OneStep = {
    DA_ASSEGNARE: 'Da Assegnare',
    DA_ESAMINARE: 'Da Esaminare',
    IN_ASSEGNAZIONE: 'In Assegnazione',
    IN_ATTESA_DI_COMPLETAMENTO: 'In Attesa di Completamento',
    CANCELLATA: 'Cancellata',
};

export const TaskStatuses_OneStep_2 = {
    DA_ASSEGNARE: 'Da Assegnare',
    DA_ESAMINARE: 'Da Esaminare',
    IN_ASSEGNAZIONE: 'In Assegnazione',
    INTERROTTA: 'Interrotta',
    IN_ATTESA_DI_COMPLETAMENTO: 'In Attesa di Completamento',
    CANCELLATA: 'Cancellata',
};

export const getTaskStatusesOneStep2Values = () => {
    return Object.values(TaskStatuses_OneStep_2);
}

export const getTaskStatusesOneStepValues = () => {
    return Object.values(TaskStatuses_OneStep);
}

export const ASSOCIAZIONE_MASSIVA_STATUS_TYPES = {
    WARNING: 'Warning',
    ERROR: 'Error',
    SUCCESS: 'Success',
};